const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "Il testo del prompt 1", answers: [], image: null },
      { id: "q2", question: "Il testo del prompt 2", answers: [], image: null },
      { id: "q3", question: "Il testo del prompt 3", answers: [], image: null },
      { id: "q4", question: "Il testo del prompt 4", answers: [], image: null },
      { id: "q5", question: "Il testo del prompt 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description:
    "Lascia che i tuoi studenti rispondano con le loro stesse parole.",
  difficulty: "ALL",
  learnLang: "italian",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Benvenuto
  
   
  Di '"Ciao" a bot per iniziare.`,
  voice: "",
  versionQuestion: "Quante domande vorresti in questo modello?",
};

export default openEnded;
